import { Fragment } from 'react';
import { Box, Grid, Typography } from '@mui/material';

import SectionTitle from '../../components/SectionTitle';

const CVCone = () => {
  const info = [
    'Khi bệnh nhân lâm sàng không ổn định và cần phải truyền nhiều dịch.',
    'Khi sử dụng thuốc với các biến chứng dự kiến qua tĩnh mạch ngoại biên trong một thời gian dài hoặc liên tục (ví dụ: dinh dưỡng cha mẹ, thuốc gây phồng rộp, chất điện phân cô đặc,\n     dung dịch tăng âm, Khác.)',
    'Khi thực hiện giám sát huyết động học xâm nhập.',
    'Trong thời gian truyền dịch gián đoạn kéo dài.',
    'Khi có tiền sử khó khăn hoặc thất bại trong việc chèn ống thông tĩnh mạch ngoại vi ngay cả khi có hướng dẫn siêu âm.',
  ];

  return (
    <Fragment>
      <SectionTitle title="2. Chỉ thị cho việc chèn ống thông tĩnh mạch trung tâm." />
      <Box sx={{ margin: '38px 0px 30px 20px' }}>
        <Grid container xs={11.8}>
          <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>
            Các chỉ dẫn cho việc chèn ống thông tĩnh mạch trung tâm như sau.
          </Typography>

          {info.map(a => {
            return (
              <Grid item xs={11.5}>
                <Typography
                  sx={{
                    fontSize: '14px',
                    lineHeight: '30px',
                    whiteSpace: 'pre-wrap',
                  }}
                >
                  • {a}
                </Typography>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Fragment>
  );
};

export default CVCone;
